import axios from "../../interceptor/ApiInterceptor";
import { useEffect, useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import authActions from "../../redux/actions/auth";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";

export const useAppoDetList = (tx) => {
  const dispatch = useDispatch();
  const [errorState, setErrorState] = useState({ error: false, errorMessage: "" });
  const [auditoriasDetalle, setAuditoriasDetalle] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [qrPago, setQrPago] = useState(null);
  const params = useParams();
  const user = useSelector(state => state.auth.user)
  const numeroDoc = user?.idNumber

  const { REACT_APP_JAVA_BE_URL } = process.env;

  const SearchAuditoriaDetalle = useCallback(() => {
    const url = `${REACT_APP_JAVA_BE_URL}/external/api/v1/faba/practicesByTransaction`;
    const payload = { tx, numeroDoc };

    setIsSearching(true);

    axios
      .post(url, payload)
      .then((res) => {
        if (res.data.ok) {
          setAuditoriasDetalle(res.data.data);
          setErrorState({ error: false, errorMessage: "" });
        } else {
          setAuditoriasDetalle([]);
          setErrorState({ error: true, errorMessage: res.data.error || "Error en la respuesta del servidor." });
        }
      })
      .catch((error) => {
        console.error("Error al obtener auditoría:", error);
        let message = "Error al obtener los datos.";

        if (error.response) {
          const { status, data } = error.response;

          if (status === 504) {
            message = "En este momento no podemos acceder al detalle. Vuelva a intentar en unos minutos.";
          } else if (status === 401) {
            dispatch(authActions.signOut(true));
            message = "Sesión expirada. Por favor, inicie sesión nuevamente.";
          } else {
            message = data?.error || message;
          }
        }

        setErrorState({ error: true, errorMessage: message });
        setAuditoriasDetalle([]);
      })
      .finally(() => setIsSearching(false));
  }, [REACT_APP_JAVA_BE_URL, tx, dispatch,numeroDoc]);


  const obtenerQRPago = useCallback(
    async (transaccion, dni) => {
      try {
        const url = `${REACT_APP_JAVA_BE_URL}/external/api/v2/addressschedule/obtenerQRPago`;
        const payload = { transaction: transaccion, dni: dni};

        const response = await axios.post(url, payload);
        const data = response.data;

        if (Array.isArray(data.image)) {
          const uint8Array = new Uint8Array(data.image);
          const binaryString = uint8Array.reduce(
            (acc, byte) => acc + String.fromCharCode(byte),
            ""
          );
          const base64String = btoa(binaryString);
          data.qrBase64 = `data:image/jpeg;base64,${base64String}`;
        }

        setQrPago(data);
      } catch (error) {
        console.error("Error en obtenerQRPago:", error);
        setErrorState({
          error: true,
          errorMessage: "No se pudo obtener el QR de pago.",
        });
      }
    },
    [REACT_APP_JAVA_BE_URL]
  );

  const addFileToComprobantes = useCallback(
    async (transaction, file) => {
      try {
        const formData = new FormData();
        formData.append("transaction", transaction);
        formData.append("file", file);

        const response = await axios.post(
          `${REACT_APP_JAVA_BE_URL}/external/api/v2/addressschedule/addFileToComprobantes`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        return response.data;
      } catch (error) {
        console.error("Error al agregar comprobante:", error);
        setErrorState({
          error: true,
          errorMessage: "No se pudo adjuntar el archivo.",
        });
        throw error;
      }
    },
    [REACT_APP_JAVA_BE_URL]
  );

  const saveComprobante = useCallback(
    async (data) => {
      try {
        const response = await axios.put(
          `${REACT_APP_JAVA_BE_URL}/external/api/v2/addressschedule/saveComprobante`,
          data,
          { headers: { "Content-Type": "application/json" } }
        );
        return response.data;
      } catch (error) {
        console.error("Error al guardar comprobante:", error);
        setErrorState({
          error: true,
          errorMessage: "No se pudo guardar el comprobante.",
        });
        throw error;
      }
    },
    [REACT_APP_JAVA_BE_URL]
  );

  
  useEffect(() => {
    if (tx && numeroDoc) {
      SearchAuditoriaDetalle();
      obtenerQRPago(tx, numeroDoc);
    }
  }, [tx, SearchAuditoriaDetalle, obtenerQRPago,numeroDoc]);

  return {
    auditoriasDetalle,
    errorState,
    isSearching,
    tx,
    qrPago,
    obtenerQRPago,
    addFileToComprobantes,
    saveComprobante,
  };
};
